import React from "react";
import { CustomContentProps, SnackbarContent, useSnackbar } from "notistack";
import Paper from "@mui/material/Paper";
import { dutyNotificationStyles } from "../Notifications/dutyNotificationStyles";
import Grid from "@mui/material/Grid";
import { IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

export type DutyNotificationSnackbarProps = {
  timeString: string;
  description: string;
  link: string;
};
export const DutyNotificationSnackbar = React.forwardRef<
  HTMLDivElement,
  DutyNotificationSnackbarProps & CustomContentProps
>(({ timeString, description, link }, ref) => {
  const { closeSnackbar } = useSnackbar();

  const closeNotification = () => {
    closeSnackbar();
  };

  return (
    <SnackbarContent ref={ref}>
      <Paper sx={dutyNotificationStyles.notificationContainer}>
        <Grid container spacing={1} sx={{
          alignItems: "center"
        }}>
          <Grid size={2} />
          <Grid sx={dutyNotificationStyles.headline} size={8}>
            Neue Pflicht für heute!
          </Grid>
          <Grid size={2}>
            <IconButton sx={dutyNotificationStyles.icon} onClick={closeNotification} size="large">
              <Close />
            </IconButton>
          </Grid>
          <Grid size={12}>
            <strong>Zeitpunkt: </strong>
            {timeString}
          </Grid>
          <Grid size={12}>
            <strong>Beschreibung: </strong>
            {description}
          </Grid>
          <Grid size={6}>
            <Button onClick={closeNotification} component={Link} to={link}>
              Zum Fall
            </Button>
          </Grid>
          <Grid size={6}>
            <Button onClick={closeNotification}>Ok</Button>
          </Grid>
        </Grid>
      </Paper>
    </SnackbarContent>
  );
});
